import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import IAppointment from '../../../_interfaces/IAppointment';
import IPatient from '../../../_interfaces/IPatients';
import ITreatment from '../../../_interfaces/ITreatment';
import { ErrorsService } from '../../../_services/errors/errors.service';
import { BaseComponent } from '../../../components/base/base.component';
import { AppointmentService } from '../../../_services/appointments/appointment.service';
import { SessionService } from '../../../_services/session/session.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { StatusComponent } from '../../../components/misc/status/status.component';
import { CurrencyPipe } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-table-patients-appointments',
  templateUrl: './table-patients-appointments.component.html',
  styleUrls: ['./table-patients-appointments.component.scss'],
  imports: [
    TableModule,
    TranslatePipe,

    ButtonModule,
    StatusComponent,
    CurrencyPipe,
  ],
})
export class TablePatientsAppointmentsComponent
  extends BaseComponent
  implements OnInit
{
  @Input('patient')
  patient: IPatient;
  appointments: IAppointment[];
  moment = moment;
  patientTreatments: ITreatment[];

  constructor(
    private messageService: MessageService,
    private appointmentsService: AppointmentService,
    private errorsService: ErrorsService,
    public translate: TranslateService,
    public session: SessionService
  ) {
    super(session);
  }

  loadAppointments() {
    return this.appointmentsService
      .getByPatient(this.customers_id, this.patient.id)
      .subscribe({
        next: (appointments: IAppointment[]) => {
          this.appointments = appointments;
        },
        error: (error) => {
          const code = this.errorsService.getMessageFromTreatmentError(error);
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant(
              'MESSAGES.TREATMENTS.ERROR.SUMMARY'
            ),
            detail: this.translate.instant(`MESSAGES.TREATMENTS.ERROR.${code}`),
          });
        },
      });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadAppointments();
  }
}
